let baseUrl = null;

export function setBaseUrl(_baseUrl) {
    baseUrl = _baseUrl.replace(/\/$/g, '');
}

function getImageUsingRequire(imageName) {
    const map = {
        'arrow.svg': require('./images/arrow.svg'),
        'back_arrow.svg': require('./images/back_arrow.svg'),
        'calendar.svg': require('./images/calendar.svg'),
        'camera_icon.svg': require('./images/camera_icon.svg'),
        'close.svg': require('./images/close.svg'),
        'default_profile.png': require('./images/default_profile.png'),
        'green_tick.svg': require('./images/green_tick.svg'),
        'grey_tick.svg': require('./images/grey_tick.svg'),
        'head_btn_icon.svg': require('./images/head_btn_icon.svg'),
        'know_more.png': require('./images/know_more.png'),
        'phone.svg': require('./images/phone.svg'),
        'points_icon.png': require('./images/points_icon.png'),
        'profile_icon.svg': require('./images/profile_icon.svg'),
        'trophy.svg': require('./images/trophy.svg'),
        'select_arrow.svg': require('./images/select_arrow.svg'),
        'upload_icon.svg': require('./images/upload_icon.svg'),
        'valid_field_tick.svg': require('./images/valid_field_tick.svg'),
        'white_arrow.svg': require('./images/white_arrow.svg'),
        'trophy_border.svg': require('./images/trophy_border.svg'),
        'tier_progress_icon.png': require('./images/tier_progress_icon.png'),
        'card_dots.svg': require('./images/card_dots.svg'),
        'pattern-bg.svg': require('./images/pattern-bg.svg'),
        'success-check.svg': require('./images/success-check.svg'),
    };
    const val = map[imageName] || require(`./images/${imageName}`);
    return val.default && val.default.src ? val.default.src : val;
}

export default function getImage(imageName) {
    if (baseUrl) {
        return `${baseUrl}/${imageName}`;
    } else {
        return getImageUsingRequire(imageName);
    }
}
